module.exports = ".login-card {\n    width: 500px;\n    margin: 50px auto;\n}\n"